/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetSpeechToTextHistoryContentRequest = {
  sttId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetSpeechToTextHistoryContentRequest$inboundSchema: z.ZodType<
  GetSpeechToTextHistoryContentRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  stt_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "stt_id": "sttId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetSpeechToTextHistoryContentRequest$Outbound = {
  stt_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetSpeechToTextHistoryContentRequest$outboundSchema: z.ZodType<
  GetSpeechToTextHistoryContentRequest$Outbound,
  z.ZodTypeDef,
  GetSpeechToTextHistoryContentRequest
> = z.object({
  sttId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    sttId: "stt_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getSpeechToTextHistoryContentRequestToJSON(
  getSpeechToTextHistoryContentRequest: GetSpeechToTextHistoryContentRequest,
): string {
  return JSON.stringify(
    GetSpeechToTextHistoryContentRequest$outboundSchema.parse(
      getSpeechToTextHistoryContentRequest,
    ),
  );
}
export function getSpeechToTextHistoryContentRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetSpeechToTextHistoryContentRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetSpeechToTextHistoryContentRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetSpeechToTextHistoryContentRequest' from JSON`,
  );
}
